import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ResidenceCardData, SearchResult } from 'features/search/types';
import { ConceptType } from 'features/search/filters/enums';

import './_residenceUsp.scss';
import { SITE, SiteId } from 'features/ui/enums';
import { getCurrentSite } from 'features/services/utils/env-helper';
import { isPast } from 'date-fns';
import { TagColor, Tags, TagDesign } from '@atoms/Tags/Tags';
import { getFormattedMessage } from 'features/services/utils/language-helper';

interface Props {
    residence: SearchResult | ResidenceCardData;
}

export const ResidenceUsp: React.FunctionComponent<Props> = ({ residence }) => {
    const currentSite = getCurrentSite();

    let inhabitDate = residence.inhabitDate;
    if(typeof inhabitDate === "string" || typeof inhabitDate === "number") {
        inhabitDate = new Date(inhabitDate);
    }
    const now = inhabitDate && isPast(inhabitDate);

    if(residence.concept !== ConceptType.PREMIUM
        && residence.concept !== ConceptType.SMARTA_KVADRAT
        && (residence.concept !== ConceptType.SENIORGARDEN && residence.siteId !== SiteId.SENIORGARDEN)
        && !now) return;

    return (
        <ul className='residence-usp__list'>
            {residence.concept === ConceptType.PREMIUM && <li>
                <Tags
                    tagText={getFormattedMessage('jm.components.ResidenceTags.premium')}
                    tagDesign={TagDesign.DEFAULT}
                    tagColor={TagColor.PREMIUM}
                />
            </li>}
            {residence.concept === ConceptType.SMARTA_KVADRAT && <li>
                <Tags
                    tagText={getFormattedMessage('jm.components.ResidenceTags.smartHousing')}
                    tagDesign={TagDesign.DEFAULT}
                    tagColor={TagColor.SMARTA}
                />
            </li>}
            {((residence.concept === ConceptType.SENIORGARDEN || residence.siteId === SiteId.SENIORGARDEN)
            && currentSite !== SITE.SENIORGARDEN) &&
                <li>
                    <Tags
                        tagText={getFormattedMessage('jm.components.ResidenceTags.senior')}
                        tagDesign={TagDesign.DEFAULT}
                        tagColor={TagColor.SENIOR}
                    />
                </li>
            }
            {now && residence.type !== 'rental' && <li>
                <Tags
                    tagText={getFormattedMessage('jm.components.ResidenceTags.moveInReady')}
                    tagDesign={TagDesign.DEFAULT}
                    tagColor={TagColor.DEFAULT}
                />
            </li>}
        </ul>
    );
}
